import { render } from "./concept-safe.vue?vue&type=template&id=308d0c94"
import script from "./concept-safe.vue?vue&type=script&lang=js"
export * from "./concept-safe.vue?vue&type=script&lang=js"

import "./concept-safe.vue?vue&type=style&index=0&id=308d0c94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__